<template>
  <v-container background fluid pa-3 v-scroll="onScrollFunction" class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top: 7px; color: #fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
    
    <filter-component :json_data="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <!-- <v-tooltip top> -->
        <v-btn
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="onHandleDialog(true, 'create', null)"
        >
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <!-- <span>{{$t('create')}}</span>
        </v-tooltip> -->
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top: 5rem; margin-bottom: 15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex
          xs12
          md4
          offset-md4
          lg2
          offset-lg5
          class="adddoc-hover"
          style="cursor: pointer"
          v-if="permission_edit == true || admin == 'true'"
        >
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top: 40px; padding-bottom: 40px"
              >
                <v-icon style="font-size: 80px" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color: #2195f3">
                  {{ $t("AddResign") }}
                </h3>
              </div>
            </template>
            <span>{{ $t("ClickFor") }} {{ $t("AddResign") }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex
            lg6
            md12
            sm12
            xs12
            pa-1
            v-for="(item, index) in table_data"
            :key="index"
            @click="
              '';

            "
          >
            <v-card
              class="coco-box-shadow"
              style="border-left: 5px solid #707070; border-radius: 5px"
            >
              <v-layout row wrap class="coco-list-layout" pa-3>
                <v-flex lg1 md1 sm1 xs2 text-xs-center style="margin: auto">
                  <v-icon :size="50" style="color: #707070">fas fa-file-contract</v-icon>
                </v-flex>
                <!-- <v-flex lg1 md1 sm2 xs3 text-xs-center>
                  <v-avatar :size="60">
                    <v-avatar
                      v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                      :size="60"
                      color="teal"
                    >
                      <span class="white--text headline">{{item.nick_name}}</span>
                    </v-avatar>

                    <Empimage
                      v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                      :json_data="item.emp_images"
                    />
                  </v-avatar>
                </v-flex> -->
                <v-flex lg9 md9 sm9 xs7 text-xs-left style="padding-left: 15px">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex lg6 md12 sm12 xs12>
                          <strong>{{ item.firstName }} {{ item.lastName }}</strong>
                          <strong
                            v-if="item.nick_name != '' && item.nick_name != null"
                            style="margin-right: 15px"
                            v-html="
                              ' (<span style=color:#166BFF;>' +
                              item.nick_name +
                              '</span>)'
                            "
                          />
                        </v-flex>
                        <v-flex lg6 md6 sm6 xs12>
                          <strong v-if="item.branch != '' && item.branch != null"
                            >{{ $t("branch") }} :
                          </strong>
                          <span>{{ item.branch }}</span>
                        </v-flex>
                        <v-flex lg6 md6 sm6 xs12>
                          <strong
                            v-if="
                              item.department_name != '' && item.department_name != null
                            "
                            >{{ $t("Department") }} :
                          </strong>
                          <span>{{ item.department_name }}</span>
                        </v-flex>
                        <v-flex lg6 md6 sm6 xs12>
                          <strong v-if="item.position != '' && item.position != null"
                            >{{ $t("Position") }} :
                          </strong>
                          <span>{{ item.position }}</span>
                        </v-flex>
                        <v-flex lg6 md6 sm6 xs12>
                          <strong>{{ $t("request_date") }} : </strong>
                          <span>{{ selectedformatDates(item.request_date) }}</span>
                        </v-flex>
                        <v-flex lg6 md6 sm6 xs12>
                          <strong>{{ $t("effective_date") }} : </strong>
                          <span>{{ selectedformatDates(item.effective_date) }}</span>
                        </v-flex>
                        <v-flex lg6 md6 sm6 xs12>
                          <span class="coco-list-label-icon" style="margin-right: 8px">
                            <v-icon style="padding-bottom: 5px">assignment</v-icon>
                            <span>{{ isEmpty(item.doc_no) ? item.doc_no : "" }}</span>
                          </span>
                        </v-flex>
                        <v-flex lg6 md6 sm6 xs12>
                          <span class="coco-list-label-icon">
                            <v-icon style="padding-bottom: 5px">info</v-icon>
                            <span>{{ isEmpty(item.remark) ? item.remark : "-" }}</span>
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- <v-flex xs12>
                      <v-layout row warp>
                        <v-flex lg6 md6 sm6 xs12>
                          <span>{{$t('request_date')}} : </span>
                          <span>{{selectedformatDates(item.request_date)}}</span>
                        
                      </v-flex>
                      <v-flex lg6 md6 sm6 xs12>
                          <span>{{$t('effective_date')}} : </span>
                          <span>{{selectedformatDates(item.effective_date)}}</span>
                        
                      </v-flex>
                      </v-layout>
                    </v-flex>    -->
                    <!-- <v-flex xs12>
                      <v-layout row warp>
                    <v-flex lg6 md6 sm6 xs12>
                      <span class="coco-list-label-icon" style="margin-right:8px;">
                        <v-icon style="padding-bottom:5px;">assignment</v-icon>
                        <span>{{isEmpty(item.doc_no) ? item.doc_no : ""}}</span>
                      </span>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs12>
                      <span class="coco-list-label-icon" v-if="item.remark != ''">
                        <v-icon style="padding-bottom:5px;">info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                    </v-flex>
                      </v-layout>
                     </v-flex> -->
                    <!-- <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">assignment</v-icon>
                        <span>{{item.doc_no}}</span>
                      </span>
                      <span
                        class="coco-list-label-icon"
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                    </v-flex>-->
                    <!-- <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-text">
                        วันที่ร้องขอ:
                        <span>{{formatDate(item.request_date, formatDates)}}</span>
                      </span>
                      <span class="coco-list-label-text">
                        วันที่มีผล:
                        <span>{{formatDate(item.effective_date, formatDates)}}</span>
                      </span>
                    </v-flex>-->
                  </v-layout>
                </v-flex>
                <v-flex lg1 md1 sm1 xs2>
                  <v-layout row wrap>
                    <v-flex lg1 md2 sm2 xs2 text-xs-right>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-menu offset-y>
                          <template slot="activator">
                            <v-btn icon style="color: rgba(0, 0, 0, 0.54)">
                              <v-icon>fas fa-ellipsis-v</v-icon>
                            </v-btn>
                          </template>
                          <v-card class="pa-0" max-width="344">
                            <v-card-title
                              class="setbox"
                              v-if="permission_view == true || admin == 'true'"
                            >
                              <v-btn
                                color="orange"
                                slot="activator"
                                flat
                                @click="onHandleDialog(true, 'update', item)"
                              >
                                <v-icon>search</v-icon>
                                <span> {{ $t("view") }}</span>
                              </v-btn>
                            </v-card-title>
                            <v-card-title
                              class="setbox"
                              v-if="permission_edit == true || admin == 'true'"
                            >
                              <v-btn color="red" flat @click="deleteItem(item)">
                                <v-icon>delete</v-icon>
                                <span> {{ $t("delete") }}</span>
                              </v-btn>
                            </v-card-title>
                          </v-card>
                        </v-menu>
                      </v-card-actions>
                    </v-flex>
                    <!-- <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3 lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex> -->
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs12 class="hidden-sm-and-up">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-xs8 xs2>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <!-- <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider" style="margin-top: 10px;">
                  <v-divider />
                </v-flex> -->
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- pagination -->
      <v-layout row wrap my-2>
        <v-flex xs12 text-xs-center>
          <div class="btn_show_pagination" style="margin-bottom: -25px">
            <v-pagination
              fixed
              v-model="pageActive"
              :length="totalPages"
              :total-visible="7"
              circle
              @input="getEmployeeList('List')"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <!-- Delete Dialog -->
      <v-flex xs12 pa-1>
        <v-dialog v-model="delDialogStatus" persistent max-width="300">
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{ $t("info.confirm_delete") }}</span>
              </v-toolbar-title>
              <v-spacer />
              <v-btn icon dark @click="delDialogStatus = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-layout row wrap pa-3>
              <v-flex xs12>
                <v-card-text>
                  ต้องการลบข้อมูลเอกสารลาออก
                  <br />
                  พนักงาน :{{ delDialog.emp_code }} ใช่หรือไม่?
                </v-card-text>
              </v-flex>
            </v-layout>
            <!-- <v-card-text>
             
              ต้องการลบข้อมูลเอกสารลาออก
              <br />
              พนักงาน :{{delDialog.emp_code}} ใช่หรือไม่?
            </v-card-text> -->
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn color="error" outline block @click="delDialogStatus = false">{{
                    $t("cancel")
                  }}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{
                    $t("submit")
                  }}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- FrmDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog" />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* jshint ignore:start */
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import Empimage from "../../components/getempimage.vue";
import store from "@/store";
import Utils from "@/utils/";
import FrmDialog from "./FormDialog";
import $ from "jquery";
import FilterComponent from "./Filter";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    Search_data: "",
    show_search: false,
    dialog_data: {
      status: false,
      save_type: String,
      data: Object,
    },
    form_dialog_data: {
      status: false,
    },
    table_data: [],
    pageActive: 1,
    totalPages: 0,
    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: "",
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    timeout: null,
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
  }),
  created: async function () {
    this.admin = localStorage._is_admin;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("ReSignList");
    // console.log(this.check_permission)
    // this.setShowFilter({
    //   status: 0
    // });
    this.commitSetToolbar({
      patternTool: "0",
    });
    this.getEmployee("newData");
    this.getResignList("Form");
    // this.$store.watch(
    //   state => {
    //     state.filter.SelectBranch;
    //     state.filter.SelectDepartment;
    //     state.filter.SelectPosition;
    //   },
    //   () => {
    //     this.pageActive = 1;
    //     this.table_data = [];
    //     this.canLoadMore = true;
    //     this.getResignList("Filter");
    //   },
    //   {
    //     deep: true
    //   }
    // );
  },
  destroyed: function () {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    Empimage,
    FrmDialog,
    FilterComponent,
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate",
    ]),
    ...mapState("app", ["showLoading", "formatDates"]),
    ...mapState("filter", ["Employee_List"]),
    ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    ...mapActions("filter", ["getEmployee"]),

    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      setTimeout(() => {
        this.getResignList();
      }, 500);
    },
    showFilter(status) {
      this.form_dialog_data = {
        status: status,
        data: 1,
      };
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
      this.getResignList();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        v.getResignList("Filter");
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $("#pagetitleshow").removeClass("showtitlepage");
      } else {
        this.show_search = true;
        $("#pagetitleshow").addClass("showtitlepage");
      }
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    getResignList(Action) {
      this.commitSetShowLoading(true);
      DocumentService.getResignList(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.Search_data,
        this.pageActive,
        this.FromDate,
        this.ToDate
      )
        .then((res) => {
          if (this.table_data.length > 0 && Action == "List") {
            if (res.data.content.length > 0) {
              res.data.content.forEach((data) => {
                this.table_data.push(data);
              });
              this.totalPages = res.data.totalPages;
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
            this.totalPages = res.data.totalPages;
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = "";
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteResign(this.delDialog.roworder)
        .then((res) => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getResignList();
          this.delDialogStatus = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span,
strong {
  font-family: "Prompt", sans-serif;
}
.setbox {
  padding: 0px !important;
  text-align: left;
  width: 100px;
}
.v-card__text {
  padding: 0px !important;
}
</style>
